import typeAndSearch from './typeAndSearch'

const organizations = {
  typeAndSearch,
}

export default organizations
